export const CustodyLock = {
    LockInBank: 'Lock in Bank',
    LockSelf: 'Lock Self',
    Release: 'Release'
  }
  
  export const CWStatus = {
    Active: 'Active',
    Inactive : 'Inactive',
  }

  
  export const CWRelatedEntites={
    CounterPart: 'CounterParty',
    Market: 'Market',
    Other: 'Other',
    Asset: 'Asset',
    Custodian: 'Custodian',
  }
  export const CustodyIntStatus = {
    ClientRequest: 'Client Request',
    CustodianRequest : 'Custodian Request',
    Executed: 'Executed',
    ClientReturned: 'Client Returned',
    Returned: 'Returned',
    Lost: 'Lost',
    ReturnRequested: 'Return Requested',
    CancelRequest: 'Cancel Request',
    Delivered: 'Delivered'
  }

  export function getCWRelatedEntities(relatedEntity) {
    switch (relatedEntity) {
      case CWRelatedEntites.CounterPart:
        return 'CounterPart';
      case CWRelatedEntites.Market:
        return 'Market';
      case CWRelatedEntites.Other:
        return 'Other';
    }
  }
  
  export function getIntStatusName(status) {
    switch (status) {
      case CWStatus.Active:
        return 'Active';
      case CWStatus.Inactive:
        return 'Inactive';
      case CWStatus.InProcess:
        return 'In Process';
      case CWStatus.Deleted:
        return 'Deleted';
      case CWStatus.Blocked:
        return 'Blocked';
      case CWStatus.Closed:
        return 'Closed';
      case CWStatus.Matured:
        return 'Matured';
    }
  }
  